class Recaptcha {
    constructor(form) {
        // Site confirm
        this.siteKey = document.body.dataset.recaptchaSiteKey;
        this.actionKey = document.body.dataset.recaptchaActionKey;

        // Form config
        this.form = form;
        this.captchaActionEl = this.actionKey ?
            this.form.querySelector(`[name="${this.actionKey}"]`) :
            null;
        this.captchaTokenEl = this.captchaActionEl ?
            this.captchaActionEl.nextElementSibling :
            null;
    }

    /**
     * Fetch Recaptcha token and submit the form.
     */
    submitForm() {
        // skip if not available
        if (!this.isAvailable()) {
            this.form.submit();
            return;
        }

        // check for existing token
        if (this.captchaTokenEl.value) {
            this.form.submit();
            return;
        }

        // fetch captcha token
        this.fetchToken();
    }

    /**
     * Check if Recaptcha is available on the form.
     */
    isAvailable() {
        // skip recaptcha if the external script has not loaded - submission will be blocked back-end
		const isReady = document.body.dataset.recaptchaIsReady === 'true';
		if (!(isReady && this.siteKey && this.actionKey)) {
			return false;
        }

        // continue to submit if captcha has not been added to the form
        if (!(this.captchaActionEl && this.captchaTokenEl)) {
            return false;
        }

        return true;
    }

    /**
     * Fetch a Google Recaptcha token.
     */
    fetchToken() {
        const formEl = this.form;
        const captchaTokenEl = this.captchaTokenEl;

        grecaptcha.execute(this.siteKey, { action: this.captchaActionEl.value }).then((token) => {
			captchaTokenEl.value = token;

			// token fetched - submit the form
            formEl.submit();
		});
    }
}

export default Recaptcha;
